<template>
  <AppHeader />
  <slot class="flex-grow-1" />
  <AppFooter />
</template>
